import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { LocalStorageService } from 'angular-2-local-storage';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  AppParamsActions,
  NAMESPACE,
  AppParamState,
} from '../app-params.reducer';

@Injectable()
export class AppParamsEffects {
  constructor(
    private action$: Actions,
    private localStorage: LocalStorageService
  ) {}

  @Effect()
  init$ = this.action$.pipe(
    ofType(AppParamsActions.INIT),
    switchMap(() => {
      const claimId = this.localStorage.get(NAMESPACE) as AppParamState;
      const poNum = this.localStorage.get('VALUTRAX-PONUM') as AppParamState;
      const isShopCptEnabled = this.localStorage.get(
        'VALUTRAX-ISSHOPCPTENABLED'
      ) as AppParamState;

      if (claimId) {
        return of(
          {
            type: AppParamsActions.UPDATE_ID_FROM_LS,
            payload: claimId,
          },
          { type: AppParamsActions.UPDATE_PO_NUM_FROM_LS, payload: poNum },
          {
            type: AppParamsActions.UPDATE_IS_SHOP_CPT_ENABLED_FROM_LS,
            payload: isShopCptEnabled,
          }
        );
      } else {
        return of({ type: AppParamsActions.KEEP_CURRENT_STATE });
      }
    })
  );

  @Effect({ dispatch: false })
  setId$ = this.action$.pipe(
    ofType(AppParamsActions.SET_ID),
    map((action: any) => {
      this.localStorage.set(NAMESPACE, action.payload);
    })
  );

  @Effect({ dispatch: false })
  setPoNum$ = this.action$.pipe(
    ofType(AppParamsActions.SET_PO_NUM),
    map((action: any) => {
      this.localStorage.set('VALUTRAX-PONUM', action.payload);
    })
  );

  @Effect({ dispatch: false })
  setIsShopCptEnabled$ = this.action$.pipe(
    ofType(AppParamsActions.SET_IS_SHOP_CPT_ENABLED),
    map((action: any) => {
      this.localStorage.set('VALUTRAX-ISSHOPCPTENABLED', action.payload);
    })
  );
}
